import config from '@/config/index';

/**
 * 增加标准提案
 *
 * @param uploadUid        标准上传者id
 * @param standardName     标准名称
 * @param organization     组织机构
 * @param legalPerson      法人
 * @param scc              统一信用码
 * @param contacts         联系人
 * @param mobile           手机号
 * @param address          地址
 * @param standardType     标准类型
 * @param isHaveZl         是否涉及专利
 * @param industryCategory 技术领域
 * @param productsServices 主要涉及的产品/服务名称
 * @param techDescription  该标准的技术创新点及先进性描述
 * @param valueDescription 该标准在相关产业（产品/服务）中的应用情况及产生的效果
 * @param statement        声明
 * @param taAttachment     提案附件
 * @param request
 * @return
 */

function addStandard() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standard`;
}

/**
 * 获取我发起的标准列表（前端用）
 *
 * @param request
 * @return@GetMapping("/standardsofmine")
 */
function getStandardsOfMine() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardsofmine`;
}

/**
    * 获取我报名参与的标准列表（前端用）
    *
    *  @RequestParam("page") int page,
           @RequestParam("limit") int limit,
           @GetMapping("/standardsreplyofmine")
    */
function getStandardsReplyOfMine() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardsreplyofmine`;
}

/**
 * 获取标准详情
 *
 * @param sid
 * @param request
 * @return@GetMapping("/standard/{sid}")
 */
function getStandardById(sid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standard/${sid}`;
}

/**
 * 修改标准立案内容（前端用）
 * @param sid
 * @param standardName     标准名称
 * @param organization     组织机构
 * @param legalPerson      法人
 * @param scc              统一信用码
 * @param contacts         联系人
 * @param mobile           手机号
 * @param address          地址
 * @param standardType     标准类型
 * @param isHaveZl         是否涉及专利
 * @param industryCategory 技术领域
 * @param productsServices 主要涉及的产品/服务名称
 * @param techDescription  该标准的技术创新点及先进性描述
 * @param valueDescription 该标准在相关产业（产品/服务）中的应用情况及产生的效果
 * @param statement        声明
 * @param taAttachment     提案附件
 * @param request
 * @return@PostMapping("/modifystandardta")
 */
function modifyStandardTA() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifystandardta`;
}

/**
 * 修改标准审核内容
 *
 * @param sid        标准id
 * @param attachment 附件
 * @param gs         公示
 * @param jhjt       计划进度截图
 * @param status     状态
 * @param request
 * @return@PostMapping("/standardcheckcontent")
 */
function modifyStandardCheckContent() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardcheckcontent`;
}

/**
 * 修改征求意见内容 （ 前端用 ）
 * @param sid        标准id
 * @param zhenqyjGs  公示内容
 * @param zhenqyjAttachment    征求意见附件
 * @param request
 * @return@PostMapping("/standardmodifyZQYJ")
 */
function modifyStandardZQYJ() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardmodifyZQYJ`;
}

/**
 * 获取标准列表（后台，后台均可用）
 *searchkey
 * page
 * limit
 * @param request
 * @return@GetMapping("/standards")
 */
function getStandards() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/standards`;
}

/**
 * 标准报名
 *
 @param sid          标准ID
      * @param uid          用户id
      * @param organization 组织机构
      * @param mobile       联系电话
      * @param contacts     联系人
      * @param applytable   报名表

 * @param request
 * @return@PostMapping("/standardapply")
 */
function addStandardApply() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardapply`;
}

/**
 * 修改起草内容 （ 前端第一次提交,  一个公示 和 第一个起草附件 ）
 *
 * @param sid        标准id
 * @param qcText       征集共同单位文本
 * @param qcAttachment 第一个附件
 * @param request
 * @return
 */
function modifyStandardQC() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardmodifyqc`;
}


/**
 * 修改起草内容 （ 前端第二次提交,  一个图片 和 第二个起草附件 ）
 *
 * @param sid        标准id
 * @param qcImage      图片
 * @param qcAttachment2nd 第二个附件
 * @param request
 * @return
 */
function modifyStandardQC2nd() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardmodifyqc2nd`
}

/**
 * 按照标准id获取报名表 (前台用 只显示已经审核过的，可见的报名。 包含 姓名，机构等)
 *
 * @param sid
 * @param request
 * @return @GetMapping("/standardappliesofshowed/{sid}")
 */
function getStandardAppliesOfShowed(sid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/standardappliesofshowed/${sid}`
}


export {
  addStandard,
  getStandardsOfMine,
  getStandardsReplyOfMine,
  getStandardById,
  getStandards,
  modifyStandardTA,
  modifyStandardQC,
  modifyStandardQC2nd,
  modifyStandardZQYJ,
  addStandardApply,
  getStandardAppliesOfShowed
}
